<template>
	<div>
		<el-form label-width="140px">
			<el-form-item :label="label">
				<el-select
					class="w-100"
					v-model="documentsRequested"
					:placeholder="placeholder"
					multiple
					filterable
					clearable
				>
					<el-option
						v-for="document in _.orderBy(documentsList, 'displayName', 'asc')"
						:key="document.id"
						:label="document.displayName"
						:value="document.id"
					></el-option>
				</el-select>

				<slot class="float-left">
					<small> {{ recipientType ? `Documents to be returned by the ${recipientType}` : 'Documents to be returned'}}</small>
				</slot>

			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { mapGetters } from "vuex"

	export default {
		name: "EmailDocuments",
		props: {
			recipientId: {
				type: [String, Number],
				required: false
			},
            recipientType: {
				type: String,
				required: false,
                default: null
			},
            documentsFor: {
                // required: false,
                type: Object,
                default: function() {
                    return {}
                }
            },
            preselectDocuments: {
                // required: false,
                type: Array,
                default: function() {
                    return []
                }
            },
            label: {
				type: String,
				required: false,
                default: 'Request Docs'
			},
            placeholder: {
				type: String,
				required: false,
                default: ''
			},
		},
		data() {
			return {
				documentsRequested: []
			}
		},
		computed: {
			...mapGetters({
				pendingApplicantDocuments: 'documents/pendingApplicantDocuments',
				pendingDealerDocuments: 'documents/pendingDealerDocuments',
				pendingSellerDocuments: 'documents/pendingSellerDocuments',
				pendingRefinanceDocuments: 'documents/pendingRefinanceDocuments',
				pendingPersonalDocuments: 'documents/pendingPersonalDocuments',
                completeDocumentsList: 'documents/completeDocumentsList',
                applicantDocumentsList: 'documents/applicantDocumentsList',
				dealerDocumentsList: "documents/dealerDocumentsList",
				sellerDocumentsList: "documents/sellerDocumentsList",
				refinanceDocumentsList: "documents/refinanceDocumentsList",
				personalDocumentsList: "documents/personalDocumentsList",
			}),
            formattedPlaceholder() {
                return this.placeholder ? this.placeholder : (this.recipientType ? `Select documents the ${this.recipientType} must provide` : `Select required documents`)
            },
            selectedDocumentsFor() {
                if (this.recipientType in this.documentsFor) {
                    if (this.documentsFor[this.recipientType]) {
                        return this.documentsFor[this.recipientType]
                    }
                }
                return false
            },
            documentsList() {
                let documentsList
                switch (this.recipientType) {
                    case 'applicant':
                        documentsList = this.applicantDocumentsList
                        break;
                    case 'dealer':
                        documentsList = this.dealerDocumentsList
                        break;
                    case 'seller':
                        documentsList = this.sellerDocumentsList
                        break;
                    default:
                        documentsList = this.applicantDocumentsList
                }

                // get only the documents passed through
                if (this.selectedDocumentsFor) {
                    return this.completeDocumentsList.filter(document => this.selectedDocumentsFor.find(documentFor => documentFor.id == document.id))
                }

                return documentsList
            }
		},
		watch: {
            preselectDocuments: {
                handler(documents) {
                    if (_.isArray(documents) && !_.isEmpty(documents)) {
                        documents.forEach(document => {
                            let preselected = this.documentsList.find(list => list.name === document)
                            if (_.has(preselected, 'id') && !this.documentsRequested.includes(preselected.id)) {
                                this.documentsRequested.push(preselected.id)
                            }
                        })
                    }
                },
                deep: true,
                immediate: true
            },
			documentsRequested: {
				handler(documents) {
					this.$emit("input", documents)
				},
				deep: true,
                immediate: true
			},
			pendingApplicantDocuments: {
				handler(documents, currentDocuments) {
                    if (this.recipientId) {
                        if (this.recipientType == 'applicant') {
                            if (documents && documents !== currentDocuments) {
                                let userDocs = documents.find((document) => Number(document.applicant_id) === Number(this.recipientId))
                                if (!_.isEmpty(userDocs)) {
                                    userDocs.documents.forEach(document => {
                                        this.documentsRequested.push(document)
                                    })
                                }
                            }
                        }
                    }
				},
                immediate: true,
				deep: true,
			},
            pendingDealerDocuments: {
				handler(documents, currentDocuments) {
                    if (this.recipientType == 'dealer' && this.$store.getters.initAppData.seller_type_id == 1) {
                        if (documents && documents !== currentDocuments) {
                            documents.forEach(document => {
                                this.documentsRequested.push(document)
                            })
                        }
                    }
				},
                immediate: true,
				deep: true,
			},
            pendingSellerDocuments: {
				handler(documents, currentDocuments) {
                    if (this.recipientType == 'seller' && (this.$store.getters.initAppData.seller_type_id == 2 || this.$store.getters.initAppData.seller_type_id == 3 || this.$store.getters.initAppData.seller_type_id == 5)) {
                        if (documents && documents !== currentDocuments) {
                            documents.forEach(document => {
                                this.documentsRequested.push(document)
                            })
                        }
                    }
				},
                immediate: true,
				deep: true,
			},
            pendingRefinanceDocuments: {
				handler(documents, currentDocuments) {
                    if (this.recipientId) {
                        if (this.recipientType == 'applicant' && this.$store.getters.initAppData.seller_type_id == 4) {
                            if (documents && documents !== currentDocuments) {
                                let applicant = this.$store.getters.initAppData.aai.find(aai => Number(aai.applicant.id) == Number(this.recipientId)).applicant
                                let userDocs = documents.find((document) => Number(document.applicant_id) === Number(applicant.user_id))
                                if (!_.isEmpty(userDocs)) {
                                    userDocs.documents.forEach(document => {
                                        this.documentsRequested.push(document)
                                    })
                                }
                            }
                        }
                    }
				},
                immediate: true,
				deep: true,
			},
            pendingPersonalDocuments: {
				handler(documents, currentDocuments) {
                    if (this.recipientId) {
                        if (this.recipientType == 'applicant' && this.$store.getters.initAppData.seller_type_id == 5) {
                            if (documents && documents !== currentDocuments) {
                                let applicant = this.$store.getters.initAppData.aai.find(aai => Number(aai.applicant.id) == Number(this.recipientId)).applicant
                                let userDocs = documents.find((document) => Number(document.applicant_id) === Number(applicant.user_id))
                                if (!_.isEmpty(userDocs)) {
                                    userDocs.documents.forEach(document => {
                                        this.documentsRequested.push(document)
                                    })
                                }
                            }
                        }
                    }
				},
                immediate: true,
				deep: true,
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
